import React, { useEffect, useState } from 'react';
import { LayoutGroup, motion } from 'motion/react';
import RotatingText from '../RotatingText';

const API = 'https://yurinkov.dev/msg.php';
const MAX_ROUNDS = 20;
const MAX_SCORE = MAX_ROUNDS * 30;   // 600

function KtoPage() {
  const [userCounts, setUserCounts] = useState({});
  const [allUsers, setAllUsers] = useState([]);
  const [round, setRound] = useState(0);
  const [score, setScore] = useState(0);
  const [choices, setChoices] = useState([]);
  const [selectedChoice, setSelectedChoice] = useState(null);
  const [correctChoice, setCorrectChoice] = useState(null);
  const [isLocked, setIsLocked] = useState(false);

  useEffect(() => {
    fetch(API)
      .then(r => r.json())
      .then(p => {
        const uc = {};
        (p.messages || []).forEach(m => {
          if (!m.user) return;
          uc[m.user] = (uc[m.user] || 0) + 1;
        });
        setUserCounts(uc);
        setAllUsers(Object.keys(uc));
      })
      .catch(() => {});
  }, []);

  const next = (forceStart = false) => {
    if (!forceStart && round >= MAX_ROUNDS) {
      setRound(MAX_ROUNDS);
      return;
    }

    const shuffled = [...allUsers].sort(() => Math.random() - 0.5).slice(0, 3);
    setChoices(shuffled);
    setRound(r => (forceStart ? 1 : r + 1));
    setSelectedChoice(null);
    setCorrectChoice(null);
    setIsLocked(false);
  };

  const restartGame = () => {
    setRound(0);
    setScore(0);
    setChoices([]);
    setSelectedChoice(null);
    setCorrectChoice(null);
    setIsLocked(false);
    next(true);
  };

  const choose = (user) => {
    if (isLocked) return;

    const correct = choices.reduce((a, b) => 
      (userCounts[a] || 0) > (userCounts[b] || 0) ? a : b
    );

    setSelectedChoice(user);
    setCorrectChoice(correct);
    setIsLocked(true);

    if (user === correct) {
      setScore(s => s + 30);
    }

    setTimeout(next, 1500);
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 text-white">
      <LayoutGroup>
        <motion.p className="flex items-center gap-2 text-6xl font-extrabold tracking-tight -mt-12 md:-mt-16 lg:-mt-20 mb-12 md:mb-16 lg:mb-20 z-20" layout>
          <motion.span layout>PESPATRON44</motion.span>
          <RotatingText
            texts={['rus', 'наш', 'zzz', 'дракон', 'круТАЯ', 'страпон']}
            mainClassName="px-3 sm:px-3 md:px-4 overflow-hidden py-1 sm:py-1 md:py-2 justify-center rounded-lg bg-gradient-to-r from-indigo-500/75 via-purple-500/75 to-pink-500/75 text-white shadow-lg"
            staggerFrom="last"
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "-120%" }}
            staggerDuration={0.025}
            splitLevelClassName="overflow-hidden pb-0.5 sm:pb-1 md:pb-1"
            transition={{ type: "spring", damping: 30, stiffness: 400 }}
            rotationInterval={2000}
          />
        </motion.p>
      </LayoutGroup>

      <div className="w-full max-w-2xl bg-gradient-to-br from-black/60 to-black/40 backdrop-blur-md border border-white/10 rounded-3xl p-6 shadow-2xl text-center">
        <h2 className="text-2xl font-bold">Кто чаще всех?</h2>
        
        <div className="text-sm text-gray-400 mb-6">
          Раунд: {Math.min(round, MAX_ROUNDS)}/{MAX_ROUNDS} — 
          Очки: <span className="text-white font-semibold">{score}</span> / {MAX_SCORE}
        </div>

        {round >= MAX_ROUNDS ? (
          <div className="mt-4 rounded-2xl border border-white/10 bg-black/40 p-6 text-left">
            <p className="text-lg font-semibold text-white">Игра окончена!</p>
            <p className="text-3xl font-bold text-white mt-2">
              {score} / {MAX_SCORE}
            </p>
            <button
              className="mt-6 w-full rounded-full bg-indigo-600 py-3 text-sm font-semibold text-white transition hover:bg-indigo-500"
              onClick={restartGame}
            >
              Играть снова
            </button>
          </div>
        ) : (
          <div>
            {choices.length === 0 ? (
              <button
                className="px-8 py-3 bg-indigo-600 hover:bg-indigo-500 rounded-2xl text-lg font-semibold transition"
                onClick={() => next(true)}
              >
                Начать игру
              </button>
            ) : (
              <div className="flex flex-col gap-3 mt-2">
                {choices.map(u => (
                  <button
                    key={u}
                    className={`w-full text-left px-5 py-3 rounded-2xl border transition-all font-medium ${
                      isLocked && correctChoice === u
                        ? 'border-emerald-400 bg-emerald-500/20 text-emerald-100'
                        : isLocked && selectedChoice === u
                          ? 'border-rose-400 bg-rose-500/20 text-rose-100'
                          : 'border-white/10 hover:bg-white/5 hover:border-white/30'
                    }`}
                    style={{ fontFamily: '"JetBrains Mono", "Fira Code", Consolas, monospace' }}
                    onClick={() => choose(u)}
                    disabled={isLocked}
                  >
                    {u}
                  </button>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default KtoPage;